export default "__VITE_ASSET__QUisE2mS__"